<div class="approval_card">
    <div class="approval_title">
        <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.COMPLETED' | transloco }}</h4>
    </div>

    <div class="approval_card_section">
        <div class="table_responsive" *ngIf="completedApprovalList?.length > 0">
            <mat-paginator
                [length]="completedApprovalList.length"
                *ngIf="completedApprovalList?.length > 10"
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 20]"
                showFirstLastButtons
            >
            </mat-paginator>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 mat-table-wrapper">
                <ng-container matColumnDef="initiator">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.INITIATOR' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.initiator }}</td>
                </ng-container>

                <ng-container matColumnDef="trigger">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.TRIGGER' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.trigger.value }}</td>
                </ng-container>
                <ng-container matColumnDef="completedDate">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.COMPLETED_DATE' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.approvedDate | customDateTimeFormat: '' }}</td>
                </ng-container>
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.ITEM' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <ng-container matColumnDef="itemType">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.ITEM_TYPE' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.item.value }}{{ element?.type ? '(' + element?.type + ')' : '' }}</td>
                </ng-container>
                <!-- <ng-container matColumnDef="by">
                    <th mat-header-cell *matHeaderCellDef>by</th>
                    <td mat-cell *matCellDef="let element">{{ element.by }}</td>
                </ng-container> -->
                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.STATE' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.state.value }}</td>
                </ng-container>
                <ng-container matColumnDef="By">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.BY' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.approvedBy }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
        <div class="no-type d-flex align-items-center justify-content-center w-100 nodata" *ngIf="completedApprovalList?.length == 0">
            <h3>{{ 'SETTING_PAGE.IDMS_SETTINGS.NO_DATA_AVAILABLE_TO_DISPLAY_HERE_PLEASE_COME_BACK_LATER' | transloco }}</h3>
        </div>
    </div>
</div>
